import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom:15px;
  font-weight: 500;
  color: #323131;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
`;
